import {
    REQUEST_BILLING_DETAIL,
    REQUEST_BILLING_DETAIL_FAILURE,
    REQUEST_BILLING_DETAIL_SUCCESS
} from "../../../constant/transaction/BillingDetailContant";


const initialState = {
    billingDetail: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const billingDetailReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case REQUEST_BILLING_DETAIL:
            return {
                ...state,
                billingDetail: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_BILLING_DETAIL_SUCCESS:
            return {
                ...state,
                billingDetail: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_BILLING_DETAIL_FAILURE:
            return {
                ...state,
                billingDetail: {
                    data: [],
                    status: 'fetching',
                    isLoading: false,
                },
            };
        default:
            return state;
    }
}
